import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../context/GlobalContext";

function Selects() {
    
    let navigate = useNavigate()

    const {lang, sectionList, setSection, openMenu, getProjectsData} = useContext(GlobalContext);

    console.log(sectionList);

    useEffect(() => {

    }, [sectionList])

    const go = (link, sect) => {
        openMenu()

        switch (link) {
            case "/contact":
                break;
            
            case "/resume":
                break;

            case "/projects":
                setSection(sect) 
                getProjectsData(sect)
                break;
        
            default:
                break;
        }

        navigate(link)
    }

    return(
        <div className="selects">
            <div className="selects__projects">
                <h3 className="selects__title">
                    {lang === "ingles" ? "Projects by Field" : "Proyectos por campo"}</h3>
                <ul className="selects__list">
                    {sectionList
                    ?
                        sectionList.map((s) => {
                            console.log(s);
                            return(
                                <li className="selects__item" onClick={() => go("/projects", s)}>{s}</li>
                            )
                        })
                    :
                    null
                    }
                </ul>
            </div>

            <div className="selects__links">
                <h3 onClick={() => go("/aboutMe", null)}>{lang === "ingles" ? "Presentation" : "Presentación"}</h3>
                <h3 onClick={() => go("/contact", null)}>{lang === "ingles" ? "Contact" : "Contacto"}</h3>
                <h3 onClick={() => go("/resume", null)}>{lang === "ingles" ? "Resume" : "Curriculum"}</h3>
            </div>
        </div>
    )
}

export default Selects